'use strict';

/**
 * Base class for utils
 *
 * @category   Utils
 * @module     base
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Util = {
    /**
     * Return a date-string formatted by the local-browser-pattern.
     *
     * @param unixTimestamp standard-mysql-unix-timestamp
     * @returns {string}
     */
    getDateFromTimestamp: function (unixTimestamp, locale) {
        var date = new Date(unixTimestamp * 1000);

        if (this.toLocaleDateStringSupportsLocales()) {
            return date.toLocaleDateString(locale, {
                month: '2-digit',
                day: '2-digit',
                year: 'numeric',
            });
        }

        return date.toLocaleDateString();
    },

    /**
     * Return a time-string formatted by the local-browser-pattern.
     *
     * @param unixTimestamp standard-mysql-unix-timestamp
     * @returns {string}
     */
    getTimeFromTimestamp: function(unixTimestamp, locale){
        var date = new Date(unixTimestamp * 1000);

        if (this.toLocaleDateStringSupportsLocales()) {
            return date.toLocaleTimeString(locale, {
                hour: '2-digit',
                minute:'2-digit',
            });
        }

        return date.toLocaleTimeString();
    },

    /**
     * Return a iso-date by given params
     *
     * @param year
     * @param month
     * @param day
     * @returns {*} e.g. (1988-09-23)
     */
    getIsoDate: function(year, month, day) {
        var date;
        if (!year) {
            date = null;
        } else if (!month) {
            date = year + '-00-00';
        } else {
            month = month + '';
            month = month.length === 1 ? '0' + month : month;

            day = day ? day + '' : '00';
            day = day.length === 1 ? '0' + day : day;

            date = year + '-' + month + '-' + day
        }

        return date;
    },

    /**
     * Return the year from given iso-date
     *
     * @param isoDate
     * @returns {Number}
     */
    getYear: function(isoDate) {
        var matches = isoDate.match(/(\d\d\d\d)-\d\d-\d\d/);

        return matches ? parseInt(matches[1], 10) : null;
    },

    /**
     * Return the month from given iso-date
     *
     * @param isoDate
     * @returns {Number}
     */
    getMonth: function(isoDate) {
        var matches = isoDate.match(/\d\d\d\d-(\d\d)-\d\d/);

        return matches ? parseInt(matches[1], 10) : null;
    },

    /**
     * Return the day from given iso-date
     *
     * @param isoDate
     * @returns {Number}
     */
    getDay: function(isoDate) {
        var matches = isoDate.match(/\d\d\d\d-\d\d-(\d\d)/);

        return matches ? parseInt(matches[1], 10) : null;
    },

    toLocaleStringSupportsLocales: function() {
        var number = 0;

        try {
            number.toLocaleString('i');
        } catch (e) {
            return e.name === 'RangeError';
        }

        return false;
    },

    toLocaleDateStringSupportsLocales: function() {
        try {
            new Date().toLocaleDateString('i');
        } catch (e) {
            return e.name === 'RangeError';
        }

        return false;
    },

    /**
     * Returns the preferred language based on the browser
     * @param {Array=}  allowedLanguages (Optional) Array with allowed languages
     * @param {string=} fallbackLanguage (Optional) Fallback language to use, if none was found
     * @returns {string} The preferred language
     */
    getPreferredLanguage: function(allowedLanguages, fallbackLanguage) {
        allowedLanguages = allowedLanguages || [];
        fallbackLanguage = fallbackLanguage || 'en';

        if (!_.isArray(allowedLanguages)) {
            allowedLanguages = [];
        }

        var lang = null;

        // Determine by browser language array
        if (navigator.languages && navigator.languages.length) {
            for (var i = 0; i < navigator.languages.length; i++) {
                var currentLanguage = navigator.languages[i].substr(0, 2);

                if (!lang && (allowedLanguages.length === 0 || _.contains(allowedLanguages, currentLanguage))) {
                    lang = currentLanguage;
                }
            }
        }

        // Determine by some other set language
        if (!lang) {
            lang = navigator.language ||
                   navigator.userLanguage ||
                   navigator.browserLanguage ||
                   navigator.systemLanguage  ||
                   fallbackLanguage;
        }

        return lang;
    },
};

module.exports = Util;